import VueApp from "../../03-fragments/vueApp/VueApp.js";

const processor = function(data) {
    return data;
}

VueApp.init({
    id: "teaserSection",
    processor: processor,
    settings: {
        customType: "project-story",
        title: "Projekte",
        root: "/projekte",
        batchCount: 6,
    },
    data: {
    },
});
